import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { LookupsRoutes } from "../lookups/routes";
import { FinComponent } from "./fin.component";
import { FinDokument } from './nalog/fin-dokument';
import { FinDokumentStavka } from './nalog/fin-dokument-stavka';
import { FinDokumentTabsComponent } from "./nalog/fin-dokument-tabs.component";
import { FinDokumentStavkaModalUpdateComponent } from "./nalog/fin-dokument-stavka-modal-update.component";
import { FinDokumentStavkaView } from "./nalog/fin-dokument-stavka-view";
import { FinDokumentView } from "./nalog/fin-dokument-view";
import { RefreshType, FormType, CanDeactivateGuard, RequestType, ModalSize, ConditionType } from "yt-ng-framework";
import { KozDokumentStavkaModalUpdateComponent } from './koz/koz-dokument-stavka-modal-update.component';
import { KozDokumentTabsComponent } from './koz/koz-dokument-tabs.component';
import { KozDokumentView } from './koz/koz-dokument-view';
import { KozDokument } from "./koz/koz-dokument";
import { KozDokumentStavkaView } from './koz/koz-dokument-stavka-view';
import { KozDokumentStavka } from "./koz/koz-dokument-stavka";
import { IzvodTabsComponent } from "./izvod/izvod-tabs.component";
import { Izvod } from "./izvod/izvod";
import { IzvodView } from "./izvod/izvod-view";
import { IzvodStavka } from "./izvod/izvod-stavka";
import { IzvodStavkaView } from "./izvod/izvod-stavka-view";
import { IzvodStavkaModalUpdateComponent } from "./izvod/izvod-stavka-modal-update.component";
import { RekapitulacijaIzvodaComponent } from "./_reports/rekapitulacija-izvoda/rekapitulacija-izvoda.component";
import { RekapitulacijaPoKomitentimaComponent } from "./_reports/rekapitulacija-po-komitentima/rekapitulacija-po-komitentima.component";
import { FilterWithBankaComponent } from "./_filters/filter-with-banka.component";
import { UvozIzvoda } from "./izvod/uvoz-izvoda";
import { UvozIzvodaComponent } from "./izvod/uvoz-izvoda.component";
import { DefaultFilter } from "../lookups/default-filter/default-filter.component";
//import { RekapitulacijaIzvodaComponent } from "./_reports/rekapitulacija-izvoda.component";

let childrenRoutes: Routes = [
    {
        path:'home',
        component:HomeComponent
    }
    , {
        path: 'nalog',
        component: FinDokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
          mainList: {
            printName: 'printaj',
            modelName: 'FinDokument',
            userRightsModelName:'nalog',
            getName: 'GetByUrl',
            getParameters: [{ Name: 'url', Value: '/fin/Nalog' }],
            modelClass: FinDokument,
            shortModelClass:FinDokumentView,
            parentProperty: '',
            tableColumns: [
                { name: 'BrojDokumenta', label: 'FINDOKUMENT.BRNAL.SINGULAR', visible:true, width: '30%' }
                ,{ name: 'Datum', label: 'FINDOKUMENT.DATNAL.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible:true, width: '20%' }
                ,{ name: 'Duguje', label: 'FINDOKUMENT.DUGUJE.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true, width: '25%' }
                ,{ name: 'Potrazuje', label: 'FINDOKUMENT.POTRAZUJE.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true, width: '25%' }
            ],
            tableColumnsSums: [
                {
                    columns: ['Duguje','Potrazuje']
                }
            ],
            sortBy: 'ID',
            sortReverse: true,
            enableEdit: true,
            enableDelete: true,
            enablePrint: true,
            formType: 'reactive',
            closeAfterSave: false,
            detailList: [
              {
                modelName: 'FinDokumentStavka',
                getName: 'getByFinDokumentID',
                getParameters: [],
                modelClass: FinDokumentStavka,
                shortModelClass: FinDokumentStavkaView,
                tableColumns: [
                    { name: 'OrgJed', label: 'FINDOKUMENTSTAVKA.ORGJED.SINGULAR', visible:true}
                    ,{ name: 'KontoSifra', label: 'FINDOKUMENTSTAVKA.KONTOSIFRA.SINGULAR', visible:true}
                    ,{ name: 'KontoNaziv', label: 'FINDOKUMENTSTAVKA.KONTONAZIV.SINGULAR', visible:true, canHide: true }    
                    ,{ name: 'Komitent', label: 'FINDOKUMENTSTAVKA.KOMITENT.SINGULAR', visible:true}                       
                    ,{ name: 'Brfak', label: 'FINDOKUMENTSTAVKA.BRFAK.SINGULAR', visible:true}
                    ,{ name: 'Datfak', label: 'FINDOKUMENTSTAVKA.DATFAK.SINGULAR',format: 'dd.MM.yyyy', visible:true, type: 'ngbDate', canHide: true }
                    ,{ name: 'Datdpo', label: 'FINDOKUMENTSTAVKA.DATDPO.SINGULAR',format: 'dd.MM.yyyy', visible:true, type: 'ngbDate', canHide: true }
                    ,{ name: 'Duguje', label: 'FINDOKUMENTSTAVKA.DUGUJE.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true}
                    ,{ name: 'Potrazuje', label: 'FINDOKUMENTSTAVKA.POTRAZUJE.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true}
                    ,{ name: 'Veza', label: 'FINDOKUMENTSTAVKA.VEZA.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true, canHide: true }
                ],
                sortBy: 'ID',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                parentProperty: 'FinDokumentID',
                updateComponent: FinDokumentStavkaModalUpdateComponent,
                formType: 'reactive',
                showOnFirstPage: true
              }
            ],
            columnClass: 'col-md-4',
            defaultListFilterComponent:DefaultFilter,
            requestType: RequestType.POST,
            defaultPropertyName: 'BrojDokumenta'
          },
          //detailList: [],
          mainTitle: 'nalog',
          updateComponent: null,
          refreshType: RefreshType.NoReload,
          loadOnInit: true,
          breadcrumbLabel: 'FINDOKUMENT.PLURAL'
        }
    }
    ,{
        path: 'koz',
        component: KozDokumentTabsComponent,
        pathMatch: 'full',
        data: {
          mainList: {
            modelName: 'KozDokument',
            getName: 'GetByUrl',
            getParameters: [{ Name: 'url', Value: '/fin/Koz' }],
            modelClass: KozDokument,
            shortModelClass:KozDokumentView,
            parentProperty: '',
            tableColumns: [
                { name: 'BrojDokumenta', label: 'KOZDOKUMENT.BROJDOKUMENTA.SINGULAR', visible:true}
                ,{ name: 'Datum', label: 'KOZDOKUMENT.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible:true}
                ,{ name: 'Komitent', label: 'KOZDOKUMENT.KOMITENT.SINGULAR', visible:true}   
                ,{ name: 'Tarifa', label: 'KOZDOKUMENT.TARIFA.SINGULAR', visible:true}  
               ],
            sortBy: 'ID',
            sortReverse: true,
            enableEdit: true,
            enableDelete: true,
            formType: 'reactive',
            closeAfterSave: false,
            detailList: [
              {
                modelName: 'KozDokumentStavka',
                getName: 'getByKozDokumentID',
                getParameters: [],
                modelClass: KozDokumentStavka,
                shortModelClass: KozDokumentStavkaView,
                tableColumns: [                     
                    { name: 'Brfak', label: 'KOZDOKUMENTSTAVKA.BRFAK.SINGULAR', visible:true}
                    ,{ name: 'Datfak', label: 'KOZDOKUMENTSTAVKA.DATFAK.SINGULAR',format: 'dd.MM.yyyy', visible:true, type: 'ngbDate'}
                    ,{ name: 'Datdpo', label: 'KOZDOKUMENTSTAVKA.DATDPO.SINGULAR',format: 'dd.MM.yyyy', visible:true, type: 'ngbDate'}
                    ,{ name: 'Iznos', label: 'KOZDOKUMENTSTAVKA.IZNOS.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true}
                ],
                sortBy: 'ID',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                parentProperty: 'KozDokumentID',
                updateComponent: KozDokumentStavkaModalUpdateComponent,
                formType: 'reactive',
                showOnFirstPage: true
              }
            ]
          },
          //detailList: [],
          mainTitle: 'koz',
          updateComponent: null,
          refreshType: RefreshType.NoReload,
          loadOnInit: true,
          breadcrumbLabel: 'KOZDOKUMENT.PLURAL'
        }
    }
    , {
        path: 'izvod',
        component: IzvodTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
          mainList: {
            label: 'TABLE.IZVODIBANKE.PLURAL',
            modelName: 'Izvod',
            userRightsModelName:'izvod',
            getName: 'GetByUrl',
            getParameters: [{ Name: 'url', Value: '/fin/Izvod' }],
            modelClass: Izvod,
            shortModelClass:IzvodView,
            parentProperty: '',
            tableColumns: [
                { name: 'BrojDokumenta', label: 'IZVOD.BROJDOKUMENTA.SINGULAR', visible:true, width:"15%"}
                ,{ name: 'Banka', label: 'IZVOD.BANKA.SINGULAR', visible:true, width:"30%"} 
                ,{ name: 'Datum', label: 'IZVOD.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible:true, width:"15%"}
                ,{ name: 'Duguje', label: 'IZVOD.DUGUJE.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true, width:"20%"}
                ,{ name: 'Potrazuje', label: 'IZVOD.POTRAZUJE.SINGULAR', format: '1.2-2', aligment: 'right', type:'number', visible:true, width:"20%"}
            ],
            tableColumnsSums: [
                {
                    columns: ['Duguje','Potrazuje']
                }
            ],
            sortBy: 'ID',
            sortReverse: true,
            enableEdit: true,
            enableDelete: true,
            enablePrint: false,
            formType: 'reactive',
            closeAfterSave: false,
            detailList: [
              {
                label: 'TABLE.IZVODIBANKESTAVKE.PLURAL',
                modelName: 'IzvodStavka',
                getName: 'getByIzvodID',
                getParameters: [],
                modelClass: IzvodStavka,
                shortModelClass: IzvodStavkaView,
                tableColumns: [
                    { name: 'RB', label: 'IZVODSTAVKA.RB.SINGULAR', width:'10%',format: '1.0-0',visible:true}
                    ,{ name: 'Komitent', label: 'IZVODSTAVKA.KOMITENT.SINGULAR',width:'25%', visible:true}    
                    , { name: 'Mesto', label: 'IZVODSTAVKA.MESTO.SINGULAR', width:'10%',visible: true, canHide: true }
                    , { name: 'BrojFakture', label: 'IZVODSTAVKA.BROJFAKTURE.SINGULAR',width:'15%', visible: true }
                    ,{ name: 'OrgJed', label: 'IZVODSTAVKA.ORGJED.SINGULAR', width:'15%',visible:true}                                
                    ,{ name: 'Duguje', label: 'IZVODSTAVKA.DUGUJE.SINGULAR', width:'10%',format: '1.2-2', aligment: 'right', type:'number', visible:true}
                    ,{ name: 'Potrazuje', label: 'IZVODSTAVKA.POTRAZUJE.SINGULAR', width:'15%', format: '1.2-2', aligment: 'right', type:'number', visible:true}
                ],               
                sortBy: 'ID',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                parentProperty: 'IzvodID',
                updateComponent: IzvodStavkaModalUpdateComponent,
                formType: 'reactive',
                showOnFirstPage: true
              }
            ],
            columnClass: 'col-md-6',
            defaultListFilterComponent:FilterWithBankaComponent,
            requestType: RequestType.POST,
            defaultPropertyName: 'BrojDokumenta'
          },
          //detailList: [],
          mainTitle: 'Izvod',
          updateComponent: null,
          refreshType: RefreshType.NoReload,
          loadOnInit: true,
          breadcrumbLabel: 'IZVOD.PLURAL'
        }
    }
    , {
      path: 'rekapitulacijaizvoda',
      component: RekapitulacijaIzvodaComponent,
      pathMatch: 'full',
      data: {
          mainList: {
              modelName: 'FinReports',
              printName: 'PrintajRekapitulacijuIzvoda',
              tableColumns: [
                  { name: 'Naziv', label: 'IZVOD.NAZIV.SINGULAR', visible: true, canHide: false }

              ],
          },
          mainTitle: 'Rekapitulacija izvoda',
          breadcrumbLabel: 'REKAPITULACIJAIZVODA.SINGULAR'
      }
  }
  , {
    path: 'rekapitulacijapokomitentima',
    component: RekapitulacijaPoKomitentimaComponent,
    pathMatch: 'full',
    data: {
        mainList: {
            modelName: 'FinReports',
            printName: 'PrintajRekapitulacijuPoKomitentima',
            tableColumns: [
                { name: 'Naziv', label: 'IZVOD.NAZIV.SINGULAR', visible: true, canHide: false }

            ],
        },
        mainTitle: 'Rekapitulacija po komitentima',
        breadcrumbLabel: 'REKAPITULACIJAPOKOMITENTIMA.SINGULAR'
    }
}
, {
    path: 'uvoz-izvoda',
    component: UvozIzvodaComponent,
    pathMatch: 'full',
    data: {
        mainList: {
            modelName: 'findokument',
            getName: 'getDokumenteByFinDokumentID',
            getParameters: [{Name: 'finDokumentID', Value: '-1'}],
            modelClass: UvozIzvoda,
            parentProperty: '',
            tableColumns: [
                { name: 'RB', label: 'UVOZIZVODA.RB.SINGULAR', visible: true, canHide: false, width:'5%' }
                ,{ name: 'ZiroRacunKomitenta', label: 'UVOZIZVODA.ZIRORACUNKOMITENTA.SINGULAR', visible: true, canHide: false, width:'25%' }
                ,{ name: 'BrojFakture', label: 'UVOZIZVODA.BROJFAKTURE.SINGULAR', visible: true, canHide: true, width:'10%' }
                ,{ name: 'Duguje', label: 'UVOZIZVODA.DUGUJE.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false, width:'20%' }
                ,{ name: 'Potrazuje', label: 'UVOZIZVODA.POTRAZUJE.SINGULAR', type:'number', format: '1.2-2', visible: true, canHide: false, width:'20%' }
                ,{ name: 'Opis', label: 'UVOZIZVODA.OPIS.SINGULAR', visible: true, canHide: true, width:'20%' }

            ],
            tableRowColors: [
                {
                    ColumnName: 'Checked',
                    Condition: ConditionType.Equals,
                    Value: true,
                    Color: '#777'
                }
            ],
            sortBy: 'Broj',
            sortReverse: true,
            enableEdit: true,
            enableDelete: true,
            formType: FormType.Reactive,
            printName: 'printaj',
            defaultPropertyName: 'Broj'                
        },
        mainTitle: 'SPISAK SA IZVODA',
        modalSize: 'xl',
        refreshType: RefreshType.Reload,
        loadOnInit: true,
        breadcrumbLabel: 'SPISAKISKORISCENIH.PLURAL',
        updateComponent: UvozIzvodaComponent
    }
}
]

childrenRoutes=childrenRoutes.concat(LookupsRoutes);

const routes: Routes = [
    {
        path: '',
        component: FinComponent,
        children: childrenRoutes
    }
   
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FinRoutingModule{}
